/** Shared category URLs for navigation, static pages, and article filtering. */
export const blogCategories = [
  {
    slug: 'comparisons',
    label: 'Comparisons',
    description:
      'Understand the tradeoffs between wallet platforms and architectures.',
    href: '/blog/category/comparisons',
  },
  {
    slug: 'guides',
    label: 'Guides',
    description: 'Practical guidance for treasury teams and onchain operators.',
    href: '/blog/category/guides',
  },
  {
    slug: 'wallet-infrastructure',
    label: 'Wallet infrastructure',
    description: 'Build digital asset products on the right wallet foundation.',
    href: '/blog/category/wallet-infrastructure',
  },
] as const;

export type BlogCategory = (typeof blogCategories)[number];

export function getBlogCategory(slug: string | undefined) {
  return blogCategories.find((category) => category.slug === slug);
}
